export const resource_server = import.meta.env.VITE_RESOURCE_SERVER;
export const auth_server = import.meta.env.VITE_AUTH_SERVER_DOMAIN;
export const otp_server = import.meta.env.VITE_OTP_SERVER; 
export const ws_server = import.meta.env.VITE_WS_SERVER